import React, { useState } from 'react'
import { Card, Collapse, Button } from 'react-bootstrap'
import FlagTable from './ProgramFlagTable'


const programTypeAsName = (programType) => {
  switch (programType) {
    case 'classic_program':
      return "Classic Programm"
    case 'region_choice_program':
      return "Regionenwahl Programm"
     case 'state_choice_program':
      return "Staatenwahl Programm"
    case 'school_choice_program':
      return "Schulwahl Programm"
    default:
      return "Unknown Program"
  }
}

// textual representation of durations, if present inWords
// is used, for less than 2 Months will just render as
// X Weeks.
const DurationInfo = ({ duration, inWords }) => {
  let displayText = inWords || `${duration} Wochen`

  return (
    <span className='text-nowrap'>{displayText}</span>
  )
}

// We use american style display for start dates, e.g. 08/2022 (August 2022)
const StartDateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit'
})

const displayDate = (dateString) => {
  const date = new Date(Date.parse(dateString))
  return StartDateFormatter.format(date)
}

const ProgramCard = ({
  id,
  destination,
  duration,
  duration_in_words,
  start_date,
  additionals,
  flags,
  absolute_price,
  rating,
  ratingsLinkPrefix,
  organisation,
  onOrderClicked,
  variant,
  program_type,
}) => {
  const [open, setOpen] = useState(false)

  const handleClick = (e) => {
    e.preventDefault()
    onOrderClicked({
      organisationId: organisation.slug,
      programType: program_type,
      programId: id,
    })
  }

  let sponsored

  const featuredCss = 'border border-primary'

  if (variant === 'priority') {
    sponsored = (
      <span data-test-id='priority-program'className='sponsored small position-absolute top-0 start-0 px-2 text-body-secondary'>
        gesponsert
      </span>
    )
  }


  return (
    <Card className={ 'program-card h-100 text-center ' + (variant === 'priority' ? featuredCss : '')}>
      {sponsored}

      <Card.Body>
        <div className='mx-auto mb-2'>
          <img
            src={organisation.logo_url}
            alt={`Organisation Logo ${organisation.shortname}`}
            loading='lazy'
            width='60'
            height='60'
          />
        </div>
        <div className='h6 fw-bold'>
          {organisation.shortname}
        </div>
        <Card.Text className='text-muted'>
          {rating.count_in_period} Bewertungen – Ø{rating.average.toFixed(2)} – "{rating.in_words}"
        </Card.Text>

        <Card.Text>
          {programTypeAsName(program_type)}
        </Card.Text>

        <div className='hstack gap-2 justify-content-center mb-2 mx-auto'>
          <span>
            {destination}
          </span>
          <div className='vr'/>
          <span>
            {displayDate(start_date)}
          </span>
          <div className='vr' />
          <DurationInfo duration={duration} inWords={duration_in_words} />
        </div>

        <Card.Title>
          ab €{new Intl.NumberFormat('de-DE', {}).format(parseFloat(absolute_price))}
        </Card.Title>
      </Card.Body>

      <Card.Footer >
        <div className='vstack gap-3 align-items-center'>
          <Button
            variant='outline-primary'
            className='text-nowrap'
            onClick={handleClick}
          >
            Gratis Katalog
          </Button>

          <Button
            variant='link'
            className='border-0 text-body-secondary text-decoration-none'
            onClick={() => setOpen(!open)}
          >
            {open
            ? (<>
              <i className='bi bi-chevron-up me-1'></i>
              <span>Details ausblenden</span>
            </>)
            : (<>
              <i className='bi bi-chevron-down me-1'></i>
              <span>zeige Details</span>
            </>)}
          </Button>
        </div>

        <Collapse in={open}>
          <div className=''>
            <Card.Text className='mt-3'>
              {additionals}
            </Card.Text>
            <FlagTable flags={flags}/>
          </div>
        </Collapse>
      </Card.Footer>
    </Card>
  )
}

export default ProgramCard
